import { z } from "zod";
import { adminUlidSchema } from "./admin-operations-core.js";
import { customerOperationsOpaqueIdSchema } from "./customer-operations-core.js";
import { staffCaseAssetV1Schema, staffCaseBookSummaryV1Schema, staffCaseFileTicketV1Schema, } from "./book-staff-case-context.js";
import { staffOrderAlertHistoryV1Schema } from "./book-staff-alert-history.js";
/**
 * Case-scoped edition, media and economics (engine E4.4) and per-recipient staff alert history
 * (E4.5) for the admin (I3, 2026-10-28). Responses carry the engine's own contracts unchanged:
 * never a raw storage key, address, recipient identity or provider id.
 */
export const adminStaffCaseSchemaVersionSchema = z.literal("2026-10-28.1");
/**
 * A support request's book. The only locator is the request: its customer, book and verified
 * print order are read from it on the server, never taken from the caller.
 */
export const adminSupportEditionSummaryCommandSchema = z
    .object({
    schemaVersion: adminStaffCaseSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
})
    .strict();
/**
 * One exact file of the request's book, as a five-minute link (recent MFA). With a proof, that
 * proof's cover, interior or page; without one, the cover or interior of the print order the
 * request was verified against.
 */
export const adminSupportEditionFileCommandSchema = z
    .object({
    schemaVersion: adminStaffCaseSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
    asset: staffCaseAssetV1Schema,
    proofId: z.string().min(1).max(240).optional(),
})
    .strict();
/** Owners only (Books and Orders pages): a book of that customer's, and optionally its order. */
export const adminBookEditionSummaryRequestSchema = z
    .object({
    schemaVersion: adminStaffCaseSchemaVersionSchema,
    customerId: customerOperationsOpaqueIdSchema,
    bookId: customerOperationsOpaqueIdSchema,
    physicalOrderId: adminUlidSchema.optional(),
})
    .strict();
export const adminStaffCaseBookSummaryResponseSchema = z
    .object({ data: staffCaseBookSummaryV1Schema })
    .strict();
export const adminStaffCaseFileTicketResponseSchema = z
    .object({ data: staffCaseFileTicketV1Schema })
    .strict();
/** Owners only: counts of the staff alerts sent about one print order, never who got them. */
export const adminStaffAlertHistoryRequestSchema = z
    .object({
    schemaVersion: adminStaffCaseSchemaVersionSchema,
    physicalOrderId: adminUlidSchema,
})
    .strict();
export const adminStaffAlertHistoryResponseSchema = z
    .object({ data: staffOrderAlertHistoryV1Schema })
    .strict();
//# sourceMappingURL=admin-operations-staff-case.js.map